<script setup lang="ts">
import { defineProps, withDefaults } from "vue";

interface Props {
  error: string;
  id: string;
}
const props = withDefaults(defineProps<Props>(), {
  error: "",
  id: undefined,
});
</script>

<template>
  <div class="error-container" v-if="props.error" tabindex="0" role="alert">
    <template v-if="props.error">
      <span class="agila-icon-error"></span>
      <span :id="props.id">{{ props.error }}</span>
    </template>
  </div>
</template>

<style lang="scss">
.error-container {
  position: relative;
  color: var(--color-red-700);
  font-family: var(--font-open-sans-regular) sans-serif;
  font-size: 13px;
  margin-top: 4px;
  min-height: 18px;
  display: flex;
  align-items: center;

  .agila-icon-error {
    margin-right: 4px;
    min-width: 14px;
    height: 14px;
  }

  span {
    line-height: 13px;
  }
}
</style>
